import { USER_ENDPOINTS } from '../config/api.config';
import { IUser } from '../types/auth.types';
import { TokenService } from './token.service';

export const UserService = {
  async getProfile(): Promise<IUser> {
    console.log('Fetching user profile...');
    const token = TokenService.getToken();
    console.log('Using token:', token);

    const response = await fetch(USER_ENDPOINTS.me(), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    console.log('Profile response status:', response.status);
    
    if (!response.ok) {
      console.error('Error response:', response);
      const error = await response.text();
      console.error('Error text:', error);
      try {
        const errorJson = JSON.parse(error);
        throw new Error(errorJson.message || 'Ошибка при получении данных пользователя');
      } catch {
        throw new Error('Ошибка при получении данных пользователя');
      }
    }

    const text = await response.text();
    console.log('Response text:', text);

    if (!text) {
      throw new Error('Сервер вернул пустой ответ');
    }

    try {
      const user = JSON.parse(text);
      console.log('Parsed user data:', user);
      console.log('User hasTestResults:', user.hasTestResults);
      TokenService.saveUser(JSON.stringify(user));
      return user;
    } catch (e) {
      console.error('JSON parse error:', e);
      throw new Error('Некорректный формат данных пользователя');
    }
  }
}; 